'use client'

import React from 'react'
import { ProgressProvider } from '@bprogress/next/app'
import '@bprogress/core/css'

const options = { showSpinner: false }
export const NavigationProgressBar = () => {
  if (process.env.NEXT_PUBLIC_HIDE_NAVIGATION_PROGRESS_BAR) return null
  return <ProgressProvider height="4px" color="#F8632C" shallowRouting options={options} />
}
